/* eslint-disable no-console */

import { Plat_isCordova } from '../Plat/Plat.device'

export const Noti_registerMessageListeners = async () => {
    if (!Plat_isCordova()) return

    if (window.FCM == null) {
        console.warn('FCM failed to load')
        return
    }

    FCM.onNotification(() => {
        // TODO handle the message in some way
    })
}
